// Dil seçici komponenti — dropdown / radio butonlu, TR / EN.
//
// Davranış:
//   - i18n.changeLanguage(code) çağrılır
//   - localStorage('hent_lang') otomatik güncellenir (i18next-browser-languagedetector)
//   - Giriş yapmış kullanıcıda /auth/profile PUT ile DB'ye yazılır
//   - HTML lang attribute güncellenir (i18n.js içinde)

import React from 'react';
import { useTranslation } from 'react-i18next';
import api from '../services/api';

const LANGS = [
  { code: 'tr', label: 'Türkçe', flag: '🇹🇷' },
  { code: 'en', label: 'English', flag: '🇬🇧' },
  // { code: 'ar', label: 'العربية', flag: '🇸🇦' }, // gelecek
];

export default function LangSwitcher({ variant = 'dropdown', onAfterChange }) {
  const { i18n, t } = useTranslation();
  const current = i18n.language?.split('-')[0] || 'tr';

  const switchTo = async (code) => {
    if (code === current) return;
    await i18n.changeLanguage(code);
    // Girişli kullanıcı için DB'ye yansıt (sessizce)
    try {
      const tok = localStorage.getItem('token');
      if (tok) {
        await api.put('/auth/profile', { language: code });
      }
    } catch { /* sessiz */ }
    if (onAfterChange) onAfterChange(code);
  };

  if (variant === 'compact') {
    // Yan yana flag buton — sidebar / header için kompakt
    return (
      <div style={{ display: 'inline-flex', gap: 4 }}>
        {LANGS.map(l => (
          <button key={l.code} onClick={() => switchTo(l.code)}
            title={l.label}
            aria-pressed={current === l.code}
            style={{
              padding: '4px 8px', fontSize: 14,
              background: current === l.code ? 'var(--accent-glow)' : 'transparent',
              border: '1px solid ' + (current === l.code ? 'var(--accent-primary)' : 'var(--border-secondary)'),
              borderRadius: 6, cursor: 'pointer',
              fontWeight: current === l.code ? 700 : 500,
            }}>
            {l.flag} {l.code.toUpperCase()}
          </button>
        ))}
      </div>
    );
  }

  // Varsayılan dropdown
  return (
    <select value={current} onChange={(e) => switchTo(e.target.value)}
      title={t('lang.switchTo', 'Change Language')}
      style={{
        padding: '6px 10px', fontSize: 13,
        background: 'var(--bg-card)', color: 'var(--text-primary)',
        border: '1px solid var(--border-secondary)', borderRadius: 6, cursor: 'pointer',
      }}>
      {LANGS.map(l => (
        <option key={l.code} value={l.code}>{l.flag} {l.label}</option>
      ))}
    </select>
  );
}

export { LANGS };
